import { Component, OnInit, ViewChild, ElementRef,Input,Output, EventEmitter } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule, AbstractControlOptions } from '@angular/forms';
import { DataService } from '../services/data.service';
import { InputValidationService } from '../helpers/validators/input-validation.service';
import { RegExValidation } from '../helpers/constants/regex-validation.constants';
import { NgbModal, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SolUserModalService } from '../services/sol-user-modal.service';
import { OtpService } from '../services/otp.service';
import { CommonModule, NgIf, PlatformLocation } from '@angular/common';
import { SecurityQuestionService } from '../services/security-question.service';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { Guid } from 'guid-typescript';
import * as $ from 'jquery';
import { Enum } from '../helpers/enums/enum';
import { RegistrationRoutingService } from '../services/registration-routing.service';
import { UserAuthService } from '../services/user-auth.service';
import { CampaignService } from '../services/campaign.service';
import { BasicInfoService } from '../services/basic-info.service';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { NumericFieldDirective } from '../helpers/directive/numeric-field.directive';
import { PasswordStrengthBar } from '../helpers/components/password-strength-bar';
import { HeaderComponent } from '../shared/header.component';
import { UtilService } from '../services/util.service';
import { FooterComponent } from '../shared/footer.component';
import { FormDirective } from '../helpers/directive/form.directive';
import { NameFieldHyphenSpaceDirective } from '../helpers/directive/name-field-hyphen-space.directive';
import { DEFAULT_MODAL_OPTIONS, ERROR_MESSAGES, MESSAGE_LINK_TEMPLATE, scrollToTop } from '../shared/constants/app.constants';
import { RegisterFormService } from '../services/register-form.service';
import { LogoComponent } from '../logo/logo.component';
@Component({
  selector: 'app-hl-registration',
  templateUrl: './hl-registration.component.html',
  styleUrls: ['./hl-registration.component.css'],
  host: {'class': 'd-flex flex-column h-100 ipadfooterbottom'},
  standalone: true,
  imports: [
      TrackingDirective,
      RouterLink,
      NgIf,
      FormsModule,
      ReactiveFormsModule,
      NumericFieldDirective,
      PasswordStrengthBar,
      CommonModule,
      NgbModule,
      HeaderComponent,
      FooterComponent,
      FormDirective,
      NameFieldHyphenSpaceDirective,LogoComponent
  ]
})
export class HLRegistrationComponent implements OnInit {
  @ViewChild('otpModel', { static: false }) otpModel: ElementRef;
  @ViewChild('captureIncomeModel', { static: false }) captureIncomeModel: ElementRef;
  @ViewChild('securityQuestionsModel', { static: false }) securityQuestionsModel: ElementRef;
  @Output()  notify:EventEmitter<string> = new EventEmitter<string>();

  modalOptions: NgbModalOptions;
  userData:'';
  registerForm; otpForm; captureIncomeForm; captureIncomeModelRef;
  errorMsg = ''; securityQuestionErrorMsg = ''; signupSuccess = false;
  otpErrorMsg = '';
  password = '';
  visible:boolean=true;
  changetype:boolean=true;
  visiblec:boolean=true;
  changetypec:boolean=true;
  captureIncomeErrorMsg = '';
  cellNumberErrorMsg = '';
  sendOtpText = 'Send SMS OTP';
  sendEmailOtpText = 'Send Email OTP';
  otpPopupHeaderText = 'Get your One-Time Pin (OTP) via SMS';
  securityQuestionList = [];
  basicInfoVerifyConfirmed: any;
  securityQuestionAttempt = 1;
  successMsg = '';
  time;
  btnOTPIsDisabled = false;
  usedOtpType;
  isOtpSent = false;
  isIdNumber = true;
  idNumber;
  registerWithIdnumberForm;
  idNumberForm;
  messageLinkTemplet = MESSAGE_LINK_TEMPLATE;
  WebSource = '';
  Params='';
  lesSuccessMsg = 'We can pre-qualify you for a Home Loan. By submitting your details you also get free access to your personalised credit dashboard and a coach to help you understand your overall credit position.' ;
  lesHeaderSuccessMsg = '<b> Sanlam </b> Credit Solutions';
  lesMiddleSuccessMsg = 'Apply Online  and see if you qualify.';
  isFirstnameSurname = false;
  internalServerErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
  isHidden: boolean = false;
  campaignCookieName: string='user_campaign';
  utm_id: string;
  isRestrictedUser: any;
  ischatbotSQConfirmed: boolean = false;
  constructor(
    private readonly userService: UserService,
    private readonly otpService: OtpService,
    private readonly dataService: DataService,
    public readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly solUserModalService: SolUserModalService,
    private readonly location: PlatformLocation,
    private readonly spinner: NgxSpinnerService,
    private readonly securityQuestionService: SecurityQuestionService,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly titleService: Title,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userAuthService: UserAuthService,
    private readonly registrationRouting: RegistrationRoutingService,
    private readonly campaignService: CampaignService,
    private readonly basicInfoService: BasicInfoService,
    private readonly utilService: UtilService,
    private readonly registerFormService: RegisterFormService
  ) {
    this.modalOptions = DEFAULT_MODAL_OPTIONS;
    location.onPopState(() => this.modalService.dismissAll());
    this.titleService.setTitle('Sanlam Credit Solutions registration page');
  }

  ngOnInit() {
    localStorage.removeItem('tempToken');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userPhoneNumber');
    this.checkPreviousUrl();
    this.userAuthService.logoutActiveUser(globalThis.location.origin + '/hl-registration');
    this.registerForm = this.registerFormService.buildRegisterForm({ includeIntermediaryCode: true });


    this.registerWithIdnumberForm = this.formBuilder.group({
      Email: ['', [Validators.required, Validators.email, InputValidationService.isValidEmail]],
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
      Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
      ConfirmPassword: ['', Validators.required],
      WebSource: '',
      Params: '',
      RegistrationSource: '',
      AcceptTerms: [false, Validators.pattern('true')],
    }, {
      validators: [InputValidationService.passwordMustMatch('Password', 'ConfirmPassword')],
    } as AbstractControlOptions);
    

    this.otpForm = this.formBuilder.group({
      Otp: ['', [Validators.required, Validators.minLength(4)]],
    });

    this.captureIncomeForm = this.formBuilder.group({
      GrossIncome: ['', [Validators.required, Validators.min(1)]],
    });

    this.idNumberForm = this.formBuilder.group({
      IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]]
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params.idnumber) {
        this.idNumber = params.idnumber;
       this.validateIdNumber();
      }
      if (params) {
        if(params.websource || params.WebSource || params.WEBSOURCE|| params.webSource){
          this.WebSource = params.websource || params.WebSource || params.WEBSOURCE|| params.webSource;
        }
        this.Params = this.registrationRouting.queryStringParams();
      }


    });
  }


  get registerFormControls() { return this.registerForm.controls; }
  get otpFormControls() { return this.otpForm.controls; }
  get captureIncomeFormControls() { return this.captureIncomeForm.controls; }
  get registerWithIdnumberFormControls() { return this.registerWithIdnumberForm.controls; }
  get idNumberFormControls() { return this.idNumberForm.controls; }

  startTimeOut() {
    globalThis.onload = () => {
      this.resetTimer();
    };

    document.onmousemove = () => {
      this.resetTimer();
    };

    document.onkeypress = () => {
      this.resetTimer();
    };

  }

  resetTimer() {
    if (this.time !== 'stop') {
      console.log('no Idle');
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        console.log('timeout');
        this.modalService.dismissAll();
        this.resetRegisterForm();
        this.errorMsg = 'Your session has timed-out. Please try to register again.';
      }, 5 * 60 * 1000);
  }
  }
  viewpass(){
    this.visible=!this.visible;
    this.changetype=!this.changetype;
  }

viewpassofConfirm(){
    this.visiblec=!this.visiblec;
    this.changetypec=!this.changetypec;
  }
  stopTimer() {
    clearTimeout(this.time);
    this.time = 'stop';
    console.log('Timer Stop');
    console.log(this.time);
  }

  private isSolUserError(err: HttpErrorResponse): boolean {
    return err?.status === 423;
  }

  validateIdNumber() {
    localStorage.removeItem('tempToken');
    const params = {
      IdNumber: this.idNumber
    }
    this.userService.validateIdNumber(params).subscribe({
      next: (data: any) => {
        localStorage.setItem('tempToken', data.token);
        this.isIdNumber = false;
        $('#id-number-form').hide();
        $('#outerText').hide();
        $('#auto-register-form').show();
        $('#auto-regitserFormText').show();
        this.registerWithIdnumberForm.patchValue({ IdNumber: this.idNumber });
      },
      error: (err: HttpErrorResponse) => {
        if (this.isSolUserError(err)) {
          this.isIdNumber = true;
          this.solUserModalService.show();
        } else if (err.status === 409) {
          this.azureAdlogin(false);
        } else {
          this.isIdNumber = true;
        }
      }
    });
  }

  registerWithIdNumber() {
    this.errorMsg = '';
    this.otpErrorMsg = '';
    this.cellNumberErrorMsg = '';
    this.securityQuestionErrorMsg = '';
    if (this.registerWithIdnumberForm.invalid) {
      this.registerWithIdnumberForm.markAllAsTouched();
      return;
    }

    this.registerWithIdnumberForm.patchValue({
      IdNumber: this.registerWithIdnumberForm.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      WebSource: this.WebSource,
      Params: this.Params,
      RegistrationSource: Enum.VersionType.HLRegistration
    });
    // console.log(this.registerForm.value)
    this.userService.registerWithIdNumber(this.registerWithIdnumberForm.value).subscribe({
      next: (data: any) => {
        if (data.status === 200) {
          this.registerForm.patchValue({ PhoneNumber: data.phoneNumber });
        this.userService.fetchUserDetailsByIdNumber(this.idNumber).subscribe({
        next: (data: any) => {
        this.ischatbotSQConfirmed = data.isVerified;
        localStorage.setItem('ischatbotSQConfirmed', this.ischatbotSQConfirmed.toString());
      }
      });
          this.validateUserBasicInfoWithBureau();
          this.startTimeOut();
        } else {
          this.errorMsg = data.message;
        }
      },
      error: (err: HttpErrorResponse) => {
        if (this.isSolUserError(err)) {
          this.solUserModalService.show();
        } else if (err.status === 409) {
          this.errorMsg = err.error.join('<br>');
        } else {
          this.errorMsg = err.error;
        }
      }
    });
    scrollToTop();
  }

  register() {
    localStorage.removeItem('tempToken');
    localStorage.removeItem('number');
    localStorage.removeItem('number');
    localStorage.removeItem('verification');
    sessionStorage.setItem('userEmail', this.registerForm.controls.Email.value);
    sessionStorage.setItem('userPhoneNumber', this.registerForm.controls.PhoneNumber.value);
    sessionStorage.setItem('userEmail', this.registerForm.controls.Email.value);
    sessionStorage.setItem('userPhoneNumber', this.registerForm.controls.PhoneNumber.value);
    this.errorMsg = '';
    this.otpErrorMsg = '';
    this.cellNumberErrorMsg = '';
    this.securityQuestionErrorMsg = '';
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    this.registerForm.patchValue({
      FirstName: this.registerForm.controls.FirstName.value.replace(RegExValidation.textName, ''),
      Surname: this.registerForm.controls.Surname.value.replace(RegExValidation.textWithSpace, ''),
      PhoneNumber: this.registerForm.controls.PhoneNumber.value.replace(RegExValidation.numeric, ''),
      IdNumber: this.registerForm.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      FinancialPlannerCode: this.registerForm.controls.FinancialPlannerCode.value.replace(RegExValidation.numeric, ''),
     WebSource: this.WebSource,
      Params: this.Params,
      RegistrationSource: Enum.VersionType.HLRegistration
    });
    this.userService.register(this.registerForm.value).subscribe({
      next: (data: any) => {
        if (data.status === 200) {
          localStorage.setItem('tempToken', data.token);
        this.userService.fetchUserDetailsByIdNumber(this.idNumber).subscribe({
        next: (data: any) => {
        this.ischatbotSQConfirmed = data.isVerified;
        localStorage.setItem('ischatbotSQConfirmed', this.ischatbotSQConfirmed.toString());
        }
        });
          this.validateUserBasicInfoWithBureau();
          this.startTimeOut();
        } else {
          this.errorMsg = data.message;
        }
      },
      error: (err: HttpErrorResponse) => {
        if (this.isSolUserError(err)) {
          this.solUserModalService.show();
        } else if (err.status === 409) {
          this.errorMsg = err.error.join('<br>');
          this.createMessageLink();
        } else if (err.status === 410) {
          this.cellNumberErrorMsg = err.error;
        } else {
          this.errorMsg = err.error;
        }
      }
    });
    scrollToTop();
  }

  resetRegisterForm() {
    this.registerForm.reset();
    this.registerForm.markAsUntouched();
  }

  validateUserBasicInfoWithBureau() {
    this.otpErrorMsg = '';
    this.basicInfoVerifyConfirmed = false;
    this.basicInfoService.validateUserBasicInfoWithBureau().subscribe({
      next: (data: any) => {
        if (data.isVerify === true) {
          this.basicInfoVerifyConfirmed = true;
          this.isRestrictedUser=false;
        } else {
          this.basicInfoVerifyConfirmed = false;
          this.isRestrictedUser=data.isRestrictedUser;
        }
        console.log(this.basicInfoVerifyConfirmed);
        localStorage.setItem('verification', this.basicInfoVerifyConfirmed);
        console.log('value of basicINfo'+this.basicInfoVerifyConfirmed);
        this.openOtpPage();
      },
      error: (err: HttpErrorResponse) => {
        this.openOtpPage();
      }
    });
  }

  openOtpPage() {
    localStorage.setItem('number', this.registerFormControls.PhoneNumber.value);
    localStorage.setItem('verification', this.basicInfoVerifyConfirmed);
    if(this.WebSource)
    {
    this.router.navigateByUrl('/otp' + this.registrationRouting.queryStringParams());
    }
    else{
    this.router.navigate(['/otp']);
    }
  }

  login() {
    this.modalService.dismissAll();
    this.stopTimer();
    this.spinner.show();
    this.azureAdlogin(true);
  }

  openGrossIncomePopup() {
    this.captureIncomeModelRef = this.modalService.open(this.captureIncomeModel, this.modalOptions);
    this.captureIncomeModelRef.result.then((result: any) => {
    }, (reason: any) => {
      if (reason === 'Cross click') {
        this.openLandingHomePage();
      }
    });
  }


  updateIncome() {
    this.captureIncomeErrorMsg = '';
    if (this.captureIncomeForm.invalid) {
      this.captureIncomeForm.markAllAsTouched();
      return;
    }

    if (this.toNumber(this.captureIncomeForm.value.GrossIncome) >= 0) {
      this.captureIncomeForm.value.GrossIncome = parseFloat(this.toNumber(this.captureIncomeForm.value.GrossIncome));
    }

    this.userService.updateGrossIncome(this.captureIncomeForm.value).subscribe((data: any) => {
      this.openLandingHomePage();
    },
      (err: HttpErrorResponse) => {
        this.captureIncomeErrorMsg = err.error;
      });
  }

  openDashboardPage() {
    this.modalService.dismissAll();
    this.router.navigate(['/portal/dashboard']);
  }

  openLandingHomePage()
  {
    this.modalService.dismissAll();
    this.router.navigate(['/portal/home']);
  }

  toNumber(val: any) {
    return this.utilService.toNumber(val);
  }

  changeGrossIncome() {
    if (this.captureIncomeForm.value.GrossIncome.toString().trim() === 'R') {
      this.captureIncomeForm.patchValue({
        GrossIncome: ''
      });
    }
  }

  azureAdlogin(isRegistrationSuccess: boolean) {
    localStorage.removeItem('tempToken');
    let submissionId = '';
    let submissionCode = Guid.create().toString();
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }

    if (isRegistrationSuccess) {
      submissionCode = '0df6b091-5d71-4f75-a6df-2d6a016e3709';
    }

    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      //get utm_id from campaign cookie
      this.campaignService.getActiveCampaign('', campaignCookie).subscribe({
        next: (data: any) => {
          if (data && data.campaignUtmId) {
            this.utm_id = data.campaignUtmId;
          }
          this.oauthService.initLoginFlow('', {
            submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
            instrumentationKey: environment.appInsights.instrumentationKey,
            utm_id: this.utm_id
          });
        },
        error: () => {}
      });

    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }
  }

  idNumberCheck(){
    localStorage.removeItem('tempToken');
    this.errorMsg = '';
    if (this.idNumberForm.invalid) {
      this.idNumberForm.markAllAsTouched();
      return;
    }
    const param = {
      IdNumber: this.idNumberForm.controls.IdNumber.value.replace(RegExValidation.numeric, ''),
      Version: Enum.VersionType.HLRegistration
    };
    this.idNumber = param.IdNumber;
    this.userService.getUserInfoByIdNumber(param).subscribe((data: any) => {
      if(data.isLead){
        this.isHidden = data.isEmailInRequestParam;
        if(this.isHidden=== true)
        {
          this.registerWithIdnumberForm = this.formBuilder.group({
            Email: ['', [Validators.email, InputValidationService.isValidEmail]],
            IdNumber: ['', [Validators.required, Validators.minLength(13), InputValidationService.isValidIdNumber]],
            Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
            ConfirmPassword: ['', Validators.required],
            WebSource: '',
            Params: '',
            RegistrationSource: '',
            AcceptTerms: [false, Validators.pattern('true')]
          }, {
            validator: [
              InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
            ],
          });
        }
        localStorage.setItem('tempToken', data.token);
        $('#id-number-form').hide();
        $('#auto-register-form').show();
        $('#auto-regitserFormText').show();
        $('#outerText').hide();
        this.registerWithIdnumberForm.patchValue({ IdNumber: this.idNumber });
        this.idNumberForm.patchValue({ IdNumber: ''});
       }
      else{
        $('#id-number-form').hide();
        $('#registerForm').show();
        $('#registerFormText').show();
        $('#outerText').hide();
        this.registerForm.patchValue({ IdNumber: this.idNumber });
        this.idNumberForm.patchValue({ IdNumber: ''});
      }
      console.log(data);
    },
    (err: HttpErrorResponse) => {
      if (this.isSolUserError(err)) {
        this.solUserModalService.show();
        return;
      }
      if (err.error?.errors) {
        this.errorMsg = Object.values(err.error.errors).flat().join('<br>');
      } else {
    
        this.errorMsg = err.error;
        this.createMessageLink();
      }


      });

     
  }
  createMessageLink(){
    if (this.errorMsg.includes('{LOGIN-LINK}'))
    {

      this.messageLinkTemplet=this.messageLinkTemplet.replace('linkText','Login').replace('routeValue','/login')
      this.errorMsg=this.errorMsg.replace('{LOGIN-LINK}',this.messageLinkTemplet);
    }
    else if(this.errorMsg.includes('{REGISTER-LINK}'))
    {
      this.messageLinkTemplet=this.messageLinkTemplet.replace('linkText','REGISTER').replace('routeValue','/register');
      this.errorMsg=this.errorMsg.replace('{REGISTER-LINK}',this.messageLinkTemplet);
    }
  }

  openSecurityQuestions() {
    this.modalService.dismissAll();
    localStorage.setItem('HLRegisterUrl', '/HL-registration');
    if(this.WebSource)
    {
    this.router.navigateByUrl('/security-question' + this.registrationRouting.queryStringParams());
    }
    else{
      this.router.navigate(['/security-question']);
    }
  }
  checkPreviousUrl()
  {
    localStorage.removeItem('HLRegisterUrl');
    localStorage.removeItem('OnLoadCheck');
    const error = localStorage.getItem('errorMsg');
   if(error === null)
   {
    localStorage.removeItem('errorMsg');
   }
  else {
    this.errorMsg = error;
    setTimeout(() => {
     localStorage.removeItem('errorMsg');
   }, 1000);}
  }

  azureActivelogin() {
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '') {
      this.campaignService.getActiveCampaign('', campaignCookie).subscribe((data: any) => {
        console.log('active campaign data', data);
        if (data && data.campaignUtmId) {
          this.utm_id = data.campaignUtmId;
        }
        this.oauthService.initLoginFlow('', {
          submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
          instrumentationKey: environment.appInsights.instrumentationKey,
          utm_id: this.utm_id
        });
      }, (error: HttpErrorResponse) => console.log(error));

    }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }
  }
}
